/* eslint-disable no-undef */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { onError, createImgUrl } from 'components_library/utils/imageUtils';
import useIntersection from 'components_library/utils/intersectionObserver';

const Image = props => {
  try {
    const [stateSrc, setstateSrc] = useState(null);
    const imgRef = useRef();
    let src = '';
    const {
      msid,
      imgsize,
      width,
      resizemode,
      height,
      placeHolderSrc,
      placeholderMsid,
      lazyload,
    } = props;

    if (msid) {
      src = createImgUrl(imgsize, msid, width, resizemode, height);
    }
    if (props.src) {
      src = props.src;
    }
    const placeHolderSrcUrl =
      placeHolderSrc ||
      createImgUrl(imgsize, placeholderMsid, width, resizemode, height);
    const reducer = (accumulator, currentValue) =>
      Object.assign(accumulator, { [currentValue[0]]: currentValue[1] });

    // retain props to be passed to the img node
    const lowerCaseProps = Object.entries(props)
      .map(item => {
        if (
          !(
            item[0] === 'src' ||
            item[0] === 'lazyload' ||
            item[0] === 'onClick' ||
            item[0] === 'onError' ||
            item[0] === 'onLoad' ||
            item[0] === 'altTitle' ||
            item[0] === 'className'
          )
        ) {
          return [item[0].toLowerCase(), item[1]];
        }
        return undefined;
      })
      .filter(item => item)
      .reduce(reducer, {});

    useIntersection(imgRef, () => {
      setstateSrc(src);
    });

    if (!lazyload) {
      return (
        <img
          src={src}
          {...lowerCaseProps}
          alt={props.altTitle}
          onError={props.onError || onError}
          {...(props.onLoad ? { onLoad: props.onLoad } : undefined)}
          onClick={props.onClick}
          className={props.className}
          onLoad={props.onLoad}
          data-isloaded="true"
        />
      );
    }

    return (
      <img
        ref={imgRef}
        alt={props.altTitle}
        {...lowerCaseProps}
        src={stateSrc || placeHolderSrcUrl}
        onError={props.onError || onError}
        onClick={props.onClick}
        className={props.className}
        data-src={src}
        onLoad={props.onLoad}
        data-api-prerender
        data-isloaded={stateSrc ? 'true' : 'false'}
      />
    );
  } catch (error) {
    return (
      <img
        src={src}
        {...lowerCaseProps}
        alt={props.altTitle}
        onError={props.onError || onError}
        onClick={props.onClick}
        className={props.className}
      />
    );
  }
};

Image.propTypes = {
  offsetVertical: PropTypes.number,
  msid: PropTypes.string,
  imgsize: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  resizemode: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  placeHolderSrc: PropTypes.string,
  placeholderMsid: PropTypes.string,
  src: PropTypes.string,
  lazyload: PropTypes.bool,
  type: PropTypes.string,
  altTitle: PropTypes.string,
  onClick: PropTypes.func,
  onLoad: PropTypes.func,
  className: PropTypes.string,
};

Image.defaultProps = {
  imgsize: '44444444',
  width: undefined,
  height: undefined,
  resizemode: 4,
  title: '',
  offsetVertical: 0,
  placeHolderSrc: '',
  placeholderMsid: '47529300',
  src: '',
  lazyload: false,
  msid: '',
  type: 'thumb',
  altTitle: '',
  onClick: () => {},
  onLoad: () => {},
  className: '',
};
export default Image;
